import { IResponse, IResponseList } from '@/types/common';
import {
  ICreateScreenMediaRequest,
  IGetListScreenMediaRequest,
  IRotationPreviewRequest,
  IUpdateScreenMediaOrderRequest,
  IUpdateScreenMediaRequest,
} from '@/types/request/screenMedia';
import {
  IGetListScreenMediaResponse,
  IRotationPreviewRow,
  IScreenMedia,
  ScreenMediaStatus,
} from '@/types/response/screenMedia';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class ScreenMedia {
  getList = (
    params?: IGetListScreenMediaRequest,
  ): Promise<IResponse<IGetListScreenMediaResponse>> =>
    axiosClient.get(ENDPOINT.SCREEN_MEDIA.GET_LIST, { params });

  getDetail = (id: number): Promise<IResponse<IScreenMedia>> =>
    axiosClient.get(
      ENDPOINT.SCREEN_MEDIA.GET_DETAIL.replace(':id', String(id)),
    );

  create = (
    body: ICreateScreenMediaRequest,
  ): Promise<IResponse<IScreenMedia>> =>
    axiosClient.post(ENDPOINT.SCREEN_MEDIA.CREATE, body);

  update = (
    body: IUpdateScreenMediaRequest,
    id: number,
  ): Promise<IResponse<IScreenMedia>> =>
    axiosClient.put(
      ENDPOINT.SCREEN_MEDIA.UPDATE.replace(':id', String(id)),
      body,
    );

  updateStatus = (
    id: number,
    status: ScreenMediaStatus,
  ): Promise<IResponse<IScreenMedia>> =>
    axiosClient.patch(
      ENDPOINT.SCREEN_MEDIA.UPDATE_STATUS.replace(':id', String(id)),
      { status },
    );

  updateOrder = (
    body: IUpdateScreenMediaOrderRequest,
  ): Promise<IResponse<{ updated: number }>> =>
    axiosClient.patch(ENDPOINT.SCREEN_MEDIA.UPDATE_ORDER, body);

  rotationPreview = (
    params: IRotationPreviewRequest,
  ): Promise<IResponseList<IRotationPreviewRow>> =>
    axiosClient.get(ENDPOINT.SCREEN_MEDIA.ROTATION_PREVIEW, { params });

  delete = (id: number) =>
    axiosClient.delete(ENDPOINT.SCREEN_MEDIA.DELETE.replace(':id', String(id)));

}

export const ScreenMediaService = new ScreenMedia();
